// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1adB1","icon":"styles_icon__2ztJA"};